<template>
    <div
        class="shareBtnWrapper"
        :class="[{ show_shareList: isShare }, dir, className]"
        @mouseenter="isEnter"
        @mouseleave="isShare = false"
    >
        <div
            class="shareBtn"
            :class="{ disable_btn: isClipBoard }"
            @click="copyLink"
            :aria-label="$t('message.share')"
            :disabled="isClipBoard"
        >
            <span
                class="save_clipboard"
                :class="[{ show_save_clipboard: isClipBoard }, dir]"
                :data-text="$t('message.copyLink')"
            ></span>

            <img src="../../assets/icons/share.svg" alt="Tvcom" />
            <div class="text">{{ $t("message.share") }}</div>
        </div>
        <div
            class="shareList"
            v-if="!this.isMobile"
            :class="{ show_shareList: isShare }"
        >
            <ul class="shareList__wrapper">
                <li class="shareList__item">
                    <a
                        :href="`https://telegram.me/share/url?url=${shareLink}`"
                        rel="noopener"
                        target="_blank"
                        class="shareList__link"
                    >
                        <div class="img">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                viewBox="0 0 15 15"
                            >
                                <path
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-linejoin="round"
                                    d="m14.5 1.5l-14 5l4 2l6-4l-4 5l6 4z"
                                />
                            </svg>
                        </div>
                        <p>Telegram</p>
                    </a>
                </li>
                <li class="shareList__item">
                    <a
                        :href="`https://www.facebook.com/sharer/sharer.php?u=${shareLink}`"
                        rel="noopener"
                        target="_blank"
                        class="shareList__link"
                    >
                        <div class="img">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    fill-rule="evenodd"
                                    d="M10.488 3.788A5.25 5.25 0 0 1 14.2 2.25h2.7a.75.75 0 0 1 .75.75v3.6a.75.75 0 0 1-.75.75h-2.7a.15.15 0 0 0-.15.15v1.95h2.85a.75.75 0 0 1 .728.932l-.9 3.6a.75.75 0 0 1-.728.568h-1.95V21a.75.75 0 0 1-.75.75H9.7a.75.75 0 0 1-.75-.75v-6.45H7a.75.75 0 0 1-.75-.75v-3.6A.75.75 0 0 1 7 9.45h1.95V7.5a5.25 5.25 0 0 1 1.538-3.712M14.2 3.75a3.75 3.75 0 0 0-3.75 3.75v2.7a.75.75 0 0 1-.75.75H7.75v2.1H9.7a.75.75 0 0 1 .75.75v6.45h2.1V13.8a.75.75 0 0 1 .75-.75h2.114l.525-2.1H13.3a.75.75 0 0 1-.75-.75V7.5a1.65 1.65 0 0 1 1.65-1.65h1.95v-2.1z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </div>
                        <p>Facebook</p>
                    </a>
                </li>
                <li class="shareList__item">
                    <div class="shareList__link" @click.prevent="copyLink">
                        <div class="img">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                viewBox="0 0 32 32"
                            >
                                <path
                                    fill="currentColor"
                                    d="M11.947 19a4.948 4.948 0 0 1-3.499-8.446l5.106-5.105a4.948 4.948 0 0 1 6.998 6.998l-.553.552l-1.415-1.413l.557-.557a2.95 2.95 0 0 0-.004-4.166a3.02 3.02 0 0 0-4.17 0l-5.104 5.104a2.947 2.947 0 0 0 0 4.17a3.02 3.02 0 0 0 4.17 0l1.414 1.414a4.92 4.92 0 0 1-3.5 1.449"
                                />
                                <path
                                    fill="currentColor"
                                    d="M19.947 17a4.948 4.948 0 0 1-3.499-8.446L17.001 8l1.414 1.415l-.552.552a2.95 2.95 0 0 0 0 4.169a3.02 3.02 0 0 0 4.17 0l5.105-5.105a2.95 2.95 0 0 0 0-4.168a3.02 3.02 0 0 0-4.17 0l-1.414-1.415a4.948 4.948 0 0 1 6.998 6.998l-5.104 5.103a4.92 4.92 0 0 1-3.5 1.45"
                                />
                                <path
                                    fill="currentColor"
                                    d="M24 30H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4v2H4v20h20V18h2v10a2 2 0 0 1-2 2"
                                />
                            </svg>
                        </div>
                        <p>{{ $t("message.copyLinkBtn") }}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ["dir", "className"],
    data() {
        return {
            isClipBoard: false,
            shareLink: window.location.href,
            isShare: false,
            isMobile: false,
        };
    },
    methods: {
        shareList(e) {
            this.isShare = !this.isShare;
        },
        isEnter() {
            if (this.isMobile) return;
            this.isShare = true;
            this.isClipBoard = false;
        },
        async copyLink() {
            this.isShare = false;

            if (this.isMobile) {
                this.share();
            } else {
                if (navigator.clipboard) {
                    await navigator.clipboard.writeText(window.location.href);
                    this.isClipBoard = true;
                    this.isShare = false;
                    setTimeout(() => {
                        this.isClipBoard = false;
                    }, 2000);
                } else {
                    alert(
                        "Ваш браузер не поддерживает функцию копирования ссылки"
                    );
                }
            }
        },
        async share() {
            if (navigator.share) {
                await navigator
                    .share({
                        title: "Ссылка на " + document.title,
                        text: document.title,
                        url: window.location.href,
                    })
                    .then(() => console.log("Удалось поделиться"))
                    .catch((error) =>
                        console.log("Не удалось поделиться", error)
                    );
            } else if (navigator.clipboard) {
                await navigator.clipboard.writeText(window.location.href);
                this.isClipBoard = true;
                this.shareList();
                setTimeout(() => {
                    this.isClipBoard = false;
                }, 2000);
            } else {
                alert("Ваш браузер не поддерживает функцию копирования ссылки");
            }
        },
        detectMob() {
            const toMatch = [
                /Android/i,
                /webOS/i,
                /iPhone/i,
                /iPad/i,
                /iPod/i,
                /BlackBerry/i,
                /Windows Phone/i,
            ];

            return toMatch.some((toMatchItem) => {
                return navigator.userAgent.match(toMatchItem);
            });
        },
    },
    mounted() {
        if (this.detectMob()) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }
    },
};
</script>

<style scoped lang="scss">
.shareBtnWrapper {
    position: relative;
    transition: 0.3s ease;
    display: inline-flex;
    z-index: 1;
    &.notext {
        .text {
            display: none;
        }
    }
    .text {
        color: #fff;
        text-align: center;
        font-size: 11px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        position: absolute;
        top: calc(100% + 6px);
        left: 50%;
        transform: translateX(-50%);
        display: none;
    }
    .shareList {
        position: absolute;
        top: 0;
        right: calc(100%);
        opacity: 0;
        pointer-events: none;
        transition: 0.3s ease;
        max-height: 0;
        padding-right: 17px;
        &.show_shareList {
            pointer-events: all;
            max-height: 140px;
            opacity: 1;
        }
        &__wrapper {
            border-radius: 4px;
            padding: 5px 5px;
            display: flex;
            flex-direction: column;
            list-style: none;
            position: relative;
            background: #262626;
            &::after {
                position: absolute;
                content: "";
                top: 7px;
                right: 0;
                width: 0;
                height: 0;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-bottom: 15px solid #262626;
                transform: rotate(90deg) translateY(-15px);
            }
        }
        &__link {
            display: flex;
            align-items: center;
            gap: 10px;
            cursor: pointer;
            transition: 0.2s;
            font-size: 14px;
            font-weight: 400;
            padding: 10px 10px;
            p {
                white-space: nowrap;
                pointer-events: none;
            }
            &:hover {
                background: #1f1e1e;
                // p,
                // .img {
                //     color: #e41a4b;
                // }
            }
            .img {
                pointer-events: none;
                svg {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
    &.ltr {
        .shareList {
            right: auto;
            left: 100%;
            padding-left: 15px;
            padding-right: 0;

            &__wrapper {
                &::after {
                    left: 0;
                    right: auto;
                    transform: rotate(-90deg) translateY(-100%);
                }
            }
        }
    }
    &.top {
        .shareList {
            right: 0;
            left: auto;
            top: calc(-255px - 17px);
            padding-left: 0;
            padding-right: 0;
            padding-bottom: 17px;
            &.show_shareList {
                pointer-events: all;
                max-height: calc(255px + 17px);
                opacity: 1;
            }
            &__wrapper {
                &::after {
                    left: auto;
                    right: 20px;
                    top: 100%;
                    transform: rotate(-180deg) translateX(2px);
                }
            }
        }
    }
    &.movieInner {
        width: 100%;
        height: 100%;
        .shareList {
            &__wrapper {
                border-radius: 12px;
                background: #292929;
                padding: 15px;
            }
            &__link {
                font-size: 20px;
                padding: 20px;
                border-radius: 3px;
                gap: 15px;
                .img {
                    svg {
                        width: 30px;
                        height: 30px;
                    }
                }
            }
        }
        .shareBtn {
            width: 100%;
            height: 100%;
            background: transparent;
            border: none;
            backdrop-filter: none;
            &:after {
                content: "";
                position: absolute;
                inset: 0;
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        .save_clipboard {
            &::before {
                right: 0;
                top: calc(-100% - 17px);
            }
        }
    }
}

.shareBtn {
    position: relative;
    border: 1px solid #7f7f7f;
    border-radius: 4px;
    background: #58585882;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    height: 43px;
    width: 43px;
    backdrop-filter: blur(3px);

    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.2s;
    &:hover {
        opacity: 0.7;
    }
}

.shareBtn > img {
    width: 22px;
}

/* Clipboard - save link */
.save_clipboard {
    transition: 0.2s;
    opacity: 0;
    pointer-events: none;
}

.show_save_clipboard {
    opacity: 1;
}

.save_clipboard:before {
    content: attr(data-text);
    position: absolute;
    top: 0;
    right: 48px;
    font-size: 16px;
    font-weight: 400;
    text-wrap: nowrap;
    background: grey;
    border-radius: 4px;
    height: 100%;
    padding: 0 10px;
    display: flex;
    align-items: center;
}
.save_clipboard.ltr:before {
    left: 48px;
    right: auto;
}
/* --//-- Clipboard - save link */

.disable_btn {
    pointer-events: none;
}

@media (max-width: 991.98px) {
    .shareBtnWrapper {
        .text {
            display: flex;
        }
    }
}

@media (max-width: 630px) {
    .shareBtn {
        width: 40px;
        height: 40px;
    }
}
</style>
